<template>
  <div class="baseline">
    <span class="caption">{{ data.caption }}</span>
    <span class="data-value"
      ><AnimatedValue :value="data.value" /> <small v-if="data.sub">{{ data.sub }}</small></span
    >
  </div>
</template>

<script>
import AnimatedValue from './../AnimatedValue';
export default {
  components: {
    AnimatedValue,
  },

  props: ['data'],
};
</script>
